<template>
  <div class="site">
    <!-- 百度地图容器 设置中心点 zoom 开启滚轮缩放 拖拽-->
    <baidu-map
      ref="baiduMap"
      style="display: flex; flex-direction: column"
      class="baiduMap"
      ak="QloR7bQpWed3VDLbtcxi2NmgUcvXxcbx"
      :center="nearby.center"
      :scroll-wheel-zoom="true"
      :zoom="zoom"
      @ready="handler"
    >
      <!-- 比例尺控件 -->
      <bm-scale anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-scale>
      <!-- 地图缩放控件 -->
      <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-navigation>
      <!-- 检索 -->
      <bm-local-search :nearby="nearby" :panel="false"></bm-local-search>
      <!-- 覆盖物 标注点-->
      <bm-marker
        v-for="(item,index) in items"
        :key="item.id"
        :position="item"
        :top="true"
        animation="BMAP_ANIMATION_BOUNCE"
        @click="infoWindowOpen(item)"
      >
        <!-- 点击标注的弹窗 -->
        <bm-info-window
          class="infowindow"
          :show="show"
          :position="item"
          :height="60"
          @close="infoWindowClose"
          @open="infoWindowOpen(item)"
        >
          <p class="info">站点名称:{{titles[index]}}</p>
          <p class="info">站点地址:{{address[index]}}</p>
        </bm-info-window>
      </bm-marker>
      <!-- 圆形 -->
      <bm-circle
        :center="nearby.center"
        :strokeOpacity="0.3"
        :fillOpacity="0.3"
        :fillColor="fillColor"
        :radius="nearby.radius"
      ></bm-circle>
      <!-- 定位控件 -->
      <bm-geolocation
        anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
        :enableGeolocation="true"
        :autoLocation="true"
        @locationSuccess="locationSuccess"
        @locationError="locationError"
      ></bm-geolocation>
    </baidu-map>
  </div>
</template>

<script>
import common from "../common";
import fetchJsonp from "fetch-jsonp";
export default {
  data() {
    return {
      zoom: 15,
      nearby: {
        center: {
          lng: 0,
          lat: 0
        },
        radius: 5000
      },
      show: false,
      fillColor: "#e7f5ff",
      items: [],
      titles: [],
      address: [],
      geotable_id: "178878",
      ak: "QloR7bQpWed3VDLbtcxi2NmgUcvXxcbx"
    };
  },
  mounted() {
    this.getData();
    window.showLocation = data => {
      var res = data.contents;
      // console.log(res); 这里是附近的站点信息
      var items = [];
      // 标注信息
      var titles = [];
      var address = [];
      // 遍历周边的站点数据
      for (let i = 0, len = res.length; i < len; i++) {
        items[i] = { lng: res[i].location[0], lat: res[i].location[1] };
        titles[i] = res[i].title;
        address[i] = res[i].address;
        this.titles[i] = titles[i];
      }
      // 周边站点的经纬度
      this.items = items;
      // 周边站点名称
      this.titles = titles;
      // 周边站点名称
      this.address = address;
    };
  },
  methods: {
    // 获取以当前位置为中心，周边站点的数据
    getData() {
      fetchJsonp(
        "https://api.map.baidu.com/geosearch/v3/nearby?location=121.532372,31.232475&radius=5000&geotable_id=178878&output=json&ak=QloR7bQpWed3VDLbtcxi2NmgUcvXxcbx&callback=showLocation",
        {
          jsonpCallback: "showLocation",
          // headers: {
          //   Accept: "application/json"
          // }
        }
      )
        .then(function(response) {
          // console.log("我是中间流对象", response);
          return response.json();
        })
        .then(function(json) {
          // console.log("真的数据应该在这里的", json);
        })
        .catch(function(ex) {
          // console.log(ex);
        });
    },
    // ready事件，获取当前的地理中心点
    handler({ BMap, map }) {
      // 这里定义的是进入地图页之后出发ready事件，设置的中心点
      this.zoom = 13;
      // 设置一个临时变量指向vue实例
      let _this = this;
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          // 设置center属性值
          _this.nearby.center = {
            lng: r.longitude,
            lat: r.latitude
          };
          //console.log("当前位置坐标", _this.nearby.center); // 当前位置坐标
          // 自定义覆盖物
          _this.autoLocationPoint = {
            lng: r.longitude,
            lat: r.latitude
          };
        },
        // 允许使用高精度定位 设置为true
        {
          enableHighAccuracy: true
        }
      );
    },
    // 打开标注信息弹窗 这个item只包含了经纬度
    infoWindowOpen(item) {
      this.show = true;
    },
    // 关闭标注信息弹窗
    infoWindowClose() {
      this.show = false;
    },
    // 点击点位控件 =>  定位到当前位置
    locationSuccess(res) {
      console.log(res);
      this.nearby.center.lng = res.point.lng;
      this.nearby.center.lat = res.point.lat;
      // 这里是点击定位之后的经纬度
      // console.log(this.nearby.center.lng);
      // console.log(this.nearby.center.lat);
    },
    // 定位失败
    locationError(err) {
      common.toast(err);
    }
  }
};
</script>

<style>
.site {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f6f8fa;
}

.baiduMap {
  flex: 1;
  width: 100%;
}

.infowindow {
  padding: 10px;
}

.info {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin: 4px 0;
}

/* Customizing Info Window */
.BMap_bubble_title {
  font-weight: 700;
  color: #106EBE;
  font-size: 16px;
  margin-bottom: 8px;
}

/* Hide Baidu Logo */
.anchorBL {
  display: none !important;
}

.anchorBL img {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/siteList.vue